import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FundShareTakeAction.css'
import config from '../../config'
import analytics from '../../helpers/analytics'
import {
  Link,
  LinkIcon,
  // SocialButtons,
  // RecentBlogPosts,
  AboutBanner,
  Returns
} from '../'
// import {Row, Col} from 'react-flexbox-grid'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'

@CSSModules(Styles)
export default class FundShareTakeAction extends Component {
  static propTypes = {
    shareClass: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props);
  }

  renderTakeAction = (shareClass) =>{
    function renderAction(info, button, link, log) {
      return (
        <div styleName='take-action-action'>
          <div styleName='take-action-info'>{info}</div>
          <div styleName='take-action-button-wrap'>
            <Link
              to={link}
              log={log}
              title={button}
            >
              <div styleName='take-action-button'>
                {button}<LinkIcon />
              </div>
            </Link>
          </div>
        </div>
      )
    }
    return (
      <div styleName='take-action-wrap'>
        <div styleName='take-action-anchor' id='take-action'/>
        <div styleName='take-action'>
          <div styleName='take-action-inner'>

            {renderAction( 'Ask your employer about fossil free options for your retirement plan',
            'Use our toolkit', config.routes.toolkit, analytics.eventToToolkit() )}

            {renderAction( 'Find sustainable funds that are A-grade fossil free',
            'Top-rated funds', config.routes.clean )}

            {renderAction( 'Divest Invest invites you to join them in pledging to invest fossil free',
            'Divest Invest pledge', config.links.pledge )}

            {renderAction( 'Visit Deforestation Free Funds to see exposure to rainforest destruction',
            'See forest risk',
            config.links.dffFund+'/'+shareClass.fund_id+'/'+shareClass.investment_vehicle_id,
            analytics.eventToFFF(shareClass.fund_id,shareClass.investment_vehicle_id) )}

          </div>
        </div>
      </div>
    )
  }

  render() {
    const shareClass = this.props.shareClass
    // <Link to={config.links.speakout} bigbutton={true}>Take Action</Link>
    return (
      <div>
        { /*
        <Returns shareClass={shareClass} url={this.props.url} />
        */ }
        
        { /*
        <div styleName='holdings-count'>
          <div styleName='holdings-count-wrap'>
            <div styleName='holdings-count-social'>
              <div styleName='holdings-count-headline'>
                What's next?
              </div>
              <div styleName='holdings-count-intro'>
                Learn how to make a change and move your money
              </div>
              <div styleName='holdings-count-intro'>
                Get started with our action toolkit
              </div>
              <div styleName='holdings-count-button'>
                <Link
                  to={config.routes.toolkit}
                  title='Fossil free action toolkit'
                  roundbutton
                >
                  Action toolkit<LinkIcon />
                </Link>
              </div>
            </div>
          </div>
        </div>
        */ }
        
        { /* <RecentBlogPosts /> */ }
        { /* this.renderTakeAction(shareClass) */ }
        { /* <div styleName='banner'>
          <div styleName='banner-inner'>
            <AboutBanner />
          </div>
        </div> */ }
      </div>
    )
  }
}